module.exports = __webpack_public_path__ + "img/Triangulum_australe.60397b9e.png";